module.exports = __webpack_public_path__ + "media/images/bookmark_star-4487cb8fcbe2faa31215ff87eb8d8bc4.svg";